import md5 from 'md5'

export const SECRET_KEY = 'WSUDD'
export const DEFAULT_SIGN_VERSION = 'X'

export const DEFAULT_SIGN_HEADER = 'X-Sign'
export const DEFAULT_SIGN_API_PATH = '/fe_api/'

export function encryptToken(config, buildURL, version = DEFAULT_SIGN_VERSION) {
  let { url = '' } = config
  const { params, paramsSerializer } = config

  url = url.slice(url.indexOf(DEFAULT_SIGN_API_PATH), url.length) // 以URI为准
  if (version === DEFAULT_SIGN_VERSION) {
    return `${version}${md5(buildURL(url, params, paramsSerializer) + SECRET_KEY)}`
  }
  return ''
}
